import React from 'react';

import AutoLogin from 'features/auth/components/AutoLogin';

export const AutoLoginPage = () => <AutoLogin />;
